const configurationEntityTypes = Object.freeze({
    BOND_DIRECTORY_FEATURE: 'BondDirectoryFeature',
    MuhuratDays: 'MuhuratDays',
    NSE_UPI_LIMIT: 'NseUpiLimit',
    CASHFREE_UPI_LIMIT: 'CashfreeUpiLimit',
    Festive_Season: 'FestiveSeason',
    FIXED_DEPOSIT_CONTENT: 'FixedDepositsContent',
    BOND_ANALYSER_DATA_REFRESHED_ON: 'BondAnalyserDataRefreshedOn',
    ABOUT_SDI: 'AboutSDI',
    MORE_ABOUT_SDI: 'MoreAboutSDI'
});

export { configurationEntityTypes };